import { createAction } from "../fns/createAction";
import { fns, libTypes } from "@holta/lib";
import { Category } from "@holta/lib/types";
import { feathersApp } from "../config/feathers";

export const setcategories = createAction("SET_PRODUCT_CATEGORIES", (newState, categories: Category[]) => {
    newState.categories = categories;
});

